export default [
    {
        path: 'orders/:orderId',
        name: 'ScannOrderItem',
        component: () => import('~cp/AdminPanel/Pages/Orders/ScannOrderItem.vue')
    },
    {
        path: 'orders-completed',
        name: 'CompletedOrders',
        component: () => import('~cp/AdminPanel/Pages/Orders/CompletedOrders.vue')
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/admin-panel-routes.js